export const TYPE_FILTERS = [
  {label: 'Item', value: 'item'},
  {label: 'Cash Fund', value: 'cash fund'},
];

export const getTypeFilterByValue = value =>
  TYPE_FILTERS.find(f => f.value === value);
